import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormControl,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
} from "@angular/forms";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";

@Component({
  selector: "app-input-percentage-filed",
  templateUrl: "./input-percentage-filed.component.html",
  styleUrls: ["./input-percentage-filed.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputPercentageFiledComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputPercentageFiledComponent),
      multi: true,
    },
  ],
})
export class InputPercentageFiledComponent implements ControlValueAccessor, OnInit, Validator {
  translationModulesEnum = TranslationModuleEnum;

  value: string = "";
  tagVal: string = "";

  @Input() id: string = "";
  @Input() labelTranslationKey: string;
  @Input() labelTranslationModuleEnum: number;
  @Input() placeholderTranslationKey: string;
  @Input() placeholderTranslationModuleEnum: number;
  @Input() style: any = {};
  @Input() title: string;
  @Input() placeholder: string = "";
  @Input() dir: string = "";
  @Input() disabled: boolean = false;
  @Input() control: FormControl | undefined;
  @Input() isNumber: boolean = false;
  @Input() isSubmitted: boolean = false;
  @Input() length: number = 0;
  @Input() minLength: number = 0;
  @Input() minValue: number = null;
  @Input() maxValue: number = null;
  @Input() showValidations: boolean = true;
  @Input() validMax: boolean = true;
  @Input() isRequired: boolean = true;
  @Input() stepNumber: string = "1";
  @Input() showPercent?: boolean = false;
  @Input() suffix?: string = "%";

  @Output() onKeyup = new EventEmitter();
  @Output() onEnter = new EventEmitter();
  @Output() onBlur = new EventEmitter();

  private onChange = (value: string) => { };
  private onTouched = () => { };
  private onValidatorChange = () => { };

  constructor() { }

  ngOnInit(): void { }

  writeValue(obj: any): void {
    this.value = obj;
    this.onChange(obj);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  change() {
    this.onChange(this.value);
  }

  focus() {
    this.onTouched();
  }

  keyup() {
    this.onKeyup.emit(this.value);
  }





  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (this.isNumber) {
      if (this.minValue != null && value < this.minValue) {
        return { minValue: { required: this.minValue, actual: value } };
      }
      if (this.maxValue != null && value > this.maxValue) {
        return { maxValue: { required: this.maxValue, actual: value } };
      }
    }

    if (this.length > 0 && value?.toString().length > this.length) {
      return { maxLength: { required: this.length, actual: value?.toString().length } };
    }

    return null;
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  onInputChange(event: Event): void {
    const input = (event.target as HTMLInputElement)?.value;
    this.value = input;
    this.onChange(input);
    this.control?.setValue(input);
    this.control?.updateValueAndValidity();
    this.onValidatorChange();
  }
}
